import { DOMRouteHandler } from '../util/Router';
import { setDeviceSpecificClickHandlers } from '../modules/featured-cards';

export class PageTemplateTempOurStory extends DOMRouteHandler {
  static init(): void {
    setDeviceSpecificClickHandlers();
  }
}
